import { render, staticRenderFns } from "./ContentPlaceholder.vue?vue&type=template&id=fd8bbc64&scoped=true&"
import script from "./ContentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ContentPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ContentPlaceholder.vue?vue&type=style&index=0&id=fd8bbc64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8bbc64",
  null
  
)

export default component.exports